import React from 'react';

import { FormStatus, SelectionMode, EntryListingMode, WorkflowStep } from 'model/dictionary';

import EntriesPage from 'components/EntriesPage';

export default function Selection() {

	return (
		<EntriesPage
			title="Preselección"
			description="Acá se preseleccionan las postulaciones confirmadas de la edición en curso. Elija un premio y valore cada postulación con la estrella, puntuándola según los criterios de evaluación. Las valoraciones de todos los seleccionadores se suman y sirven para elegir a los finalistas; una vez elegidos, las postulaciones de ese premio dejan de aparecer acá."
			searchable
			workflowStep={WorkflowStep.REVIEW}
			entryListMode={EntryListingMode.CRITERIA}
			formStatusFiltered={FormStatus.CONFIRMED}
			selectionMode={SelectionMode.SIMPLE}
		/>
	);

}
